import { axios } from "../../utils";

export async function addCategory({ formData, accessToken }) {
  const response = await axios.post(
    "/category",
    {
      categoryName: formData.categoryName,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return response;
}
